<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <trafik-cezasi-hesap-plani-create-or-update v-model="hesapPlani"></trafik-cezasi-hesap-plani-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    :items-provider="provider"
                    :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import NetsisOperationsApi from '@/api/netsis-operations';
import TrafikCezasiHesapPlaniCreateOrUpdate from './components/TrafikCezasiHesapPlaniCreateOrUpdate.vue';

export default {
    components:{
        BCard,
        TrafikCezasiHesapPlaniCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {thClass:'w-20',key:'NetsisAccountCode',name:'Hesap Plani'},
                {thClass:'w-20',key:'CollarStatusName',name:'Yaka'},
                {thClass:'w-20',key:'B_A',name:'Borç/Alacak'},
                {thClass:'w-20',key:'G_R',name:'Proje Kodu'},
                {thClass:'w-20',key:'NetsisTrafikCezasiYansitmaMerkeziTypeName',name:'Yansıtma Merkezi'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            loading:false,
            editing:false,
            hesapPlani:{
                Id:null,
                NetsisAccountCode: null,
                CollarStatusId: null,
                B_A: null,
                G_R: null,
                NetsisTrafikCezasiYansitmaMerkeziType: null
            }
        } 
    },
    methods:{
        clearForm(){
            this.editing = false
            this.hesapPlani.Id = null
            this.hesapPlani.NetsisAccountCode = null
            this.hesapPlani.CollarStatusId = null
            this.hesapPlani.B_A = null
            this.hesapPlani.G_R = null
            this.hesapPlani.NetsisTrafikCezasiYansitmaMerkeziType = null
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.hesapPlani.Id = item.Id
            this.hesapPlani.NetsisAccountCode = item.NetsisAccountCode
            this.hesapPlani.CollarStatusId = item.CollarStatusId
            this.hesapPlani.B_A = item.B_A
            this.hesapPlani.G_R = item.G_R
            this.hesapPlani.NetsisTrafikCezasiYansitmaMerkeziType = item.NetsisTrafikCezasiYansitmaMerkeziType
            this.$showModal('create-or-update')
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return NetsisOperationsApi.TrafikCezasıHesapPlanı.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            NetsisOperationsApi.TrafikCezasıHesapPlanı.CreateOrUpdate(this.editing,this.hesapPlani).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem trafik cezası hesap planı kaydını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    NetsisOperationsApi.TrafikCezasıHesapPlanı.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>